/*
Sohel 03/20/2023 2699762545 Added BasicInfo Screen
Sohel 03/20/2023 2699762545 Change Amount Field
Akhila 03/20/2023 2699762545 Added lookup dropdown and validation
Sohel 03/21/2023 2699762545 Accept Numbers Only
Sohel 03/24/2023 2699762545 Integrate isActive checkbox
Guru Prasad 03/23/2023 2699762545 Fixed scrolling issues
Ravi 03/23/2023 2699762545 Add doller in amount texfield
Dilip 03/24/2023 2699762545 fixed  prepopulate issue
Prakash 03/24/2023 2699762545 Fixed syntax issue.
Sohel 03/25/2023 2699762545 Fixed isDraft Issue
Sohel 03/27/2023 2699762545 Payload Changes
Sohel 03/27/2023 2699762545 Added validation for letter code
Akhila 03/27/2023 2699762545 Added save button and condition for letter type
Sohel 03/27/2023 2699762545 Added validations for letter maintenance
Sohel 03/28/2023 2699762545 Next Letter Validation Changes
Sohel 03/28/2023 2699762545  Update method for min value in Add letter maintenance
Sohel 03/30/2023 2699762545 Change letter Type Value
Guru Prasad 04/03/2023 2699762545 Fixed column spacing issues
Sohel 04/08/2023 2699762545 Letter Type Payload changes
Sohel 04/10/2023 3225736869 Fixed Letter Type Payload Changes
Prakash 10/04/2023 2699762545 fixed check box color
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Sohel 04/19/2023 3225736869 Fixed unsaved popup Issue
Akhila 05/24/2024 2699762545 role access implemeneted
Akhila 05/30/2023 2699762545 unsaved changes bug fixed
Ravi 06/21/2023 2699762545 fixed submit issue
*/
import {
  Button,
  FormHelperText,
  MenuItem,
  InputAdornment,
  TextField,
  FormControlLabel,
  FormControl,
  Checkbox,
} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useRef, useState, useContext} from 'react';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useSelector, useDispatch} from 'react-redux';
import * as Yup from 'yup';
import {
  postLetterBasicInfo,
  fetchBasicInfoData,
  resetBasicInfo,
  fetchAllLetterCode,
  getDropDownData,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {upperCaseCode} from '../../../components/UpperCaseCode';
import {Currency, positiveNumberOnly} from '../../../util/Currency';
import {LETTER_TYPE, LETTER_FOR, DELIVERY_METHOD} from '../../../constants/Lookup';
import {getObject, getValueObject} from '../../../util/GetDropdownObject';
import {codeRegex} from '../../../util/RegexPatterns';
import {codeValidationMessage} from '../../../util/Content';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const PlOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];
const IsCollectionOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const BasicInfo = ({
  handleHideStep,
  handleNext,
  activeStep,
  handleDirty,
  LetterMainAccess,
  editExisting,
}) => {
  const {reusableInputStyles, sideNavSection} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [codePopover, setCodePopover] = useState(false);
  const [filterCodesData, setFilterCodesData] = useState();
  const saveRef = useRef();
  const codeRef = useRef();

  const {
    letterCode,
    basicInfoData,
    isBasicInfoLoading,
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    dropDownData,
    allLetterCode,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    return label;
  };
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.categoryCode === option) {
          label = item;
        }
      });
    return label;
  };

  const checkTranslationCodeExist = (value) => {
    if (allLetterCode && allLetterCode?.length > 0 && value) {
      const ar = [];
      allLetterCode.filter((i) => {
        if (i?.letterCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const getFilterCodesData = () => {
    if (allLetterCode && allLetterCode?.length > 0) {
      return allLetterCode?.filter((i) => String(i?.letterCode)?.startsWith(filterCodesData));
    } else {
      return [];
    }
  };

  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    if (letterCode) {
      dispatch(fetchBasicInfoData(letterCode));
    }
  }, [letterCode]);
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
        if (basicInfoSuccessMsg && !saveRef.current && basicInfoStatus === 200) {
          handleNext('0');
        } else if (basicInfoSuccessMsg && saveRef.current && basicInfoStatus === 200) {
          dispatch(fetchBasicInfoData(letterCode));
        }
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);
  useEffect(() => {
    dispatch(fetchAllLetterCode());
  }, []);
  const initialState = {
    deliveryMethod: basicInfoData?.deliveryMethod ?
      getObject(basicInfoData?.deliveryMethod, DELIVERY_METHOD, dropDownData) :
      '',
    isCollection: basicInfoData?.isCollection ?
      getObjects(basicInfoData?.isCollection, IsCollectionOptions) :
      '',
    isPl95: basicInfoData?.isPL95 ? getObjects(basicInfoData?.isPL95, PlOptions) : '',
    letterCode: basicInfoData?.letterCode ? basicInfoData?.letterCode : '',
    letterDescription: basicInfoData?.letterDescription ? basicInfoData?.letterDescription : '',
    letterFor: basicInfoData?.letterFor ?
      getObject(basicInfoData?.letterFor, LETTER_FOR, dropDownData) :
      '',
    letterType: basicInfoData?.letterType ?
      getValueObject(basicInfoData?.letterType, LETTER_TYPE, dropDownData) :
      '',
    daysInAgency: basicInfoData?.daysInAgency ? basicInfoData?.daysInAgency : '',
    minimumBalance: basicInfoData?.minimumBalance ? basicInfoData?.minimumBalance : 0,
    minimumDaysForResend: basicInfoData?.minDaysResend?.toString() ?
      basicInfoData?.minDaysResend?.toString() :
      '',
    minimumGapForNextLetter: basicInfoData?.minDaysNextLetter?.toString() ?
      basicInfoData?.minDaysNextLetter?.toString() :
      '',
    minimumGapFromLastLetter: basicInfoData?.minDaysLastLetter?.toString() ?
      basicInfoData?.minDaysLastLetter?.toString() :
      '',
    isActive:
      basicInfoData?.isActive === 'Y' ? true : basicInfoData?.isActive === 'N' ? false : true,
  };

  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      balanceType: '',
      daysInAgency: values?.daysInAgency ? values?.daysInAgency : '',
      deliveryMethod: values?.deliveryMethod ? values?.deliveryMethod?.value : '',
      docKey: '',
      fileName: '',
      includeDispotions: '',
      isCollection: values?.isCollection ? values?.isCollection?.key : '',
      isDraft: basicInfoData?.isDraft === 'N' ? 'N' : 'Y',
      isPL95: values?.isPl95 ? values?.isPl95?.key : '',
      lastStep: basicInfoData?.lastStep > 1 ? basicInfoData?.lastStep : 1,
      letterCode: values?.letterCode ? values?.letterCode : '',
      letterDescription: values?.letterDescription ? values?.letterDescription : '',
      letterGroupCode: '',
      letterId: basicInfoData?.letterId ? basicInfoData?.letterId : 0,
      letterType: values?.letterType?.value ? values?.letterType?.value : '',
      minDaysLastLetter: Number(values?.minimumGapFromLastLetter),
      minDaysNextLetter: Number(values?.minimumGapForNextLetter),
      minDaysResend: Number(values?.minimumDaysForResend),
      minimumBalance: Number(values?.minimumBalance),
      letterFor: values?.letterFor ? values?.letterFor?.value : '',
      isActive: values?.isActive ? 'Y' : 'N',
    };
    dispatch(postLetterBasicInfo(payload));
  };
  const validationSchema = Yup.object().shape({
    letterCode: basicInfoData?.letterCode ?
      null :
      Yup.string()
        .required('Letter Code is required')
        .matches(codeRegex, codeValidationMessage)
        .test('code', 'Letter Code already exist', (value) => !checkTranslationCodeExist(value)),
    letterDescription: Yup.string().required('Letter Description Code is required'),
    daysInAgency: Yup.number().required('Days In Agency is required'),
    letterType: Yup.mixed().test('LetterType', 'Letter Type  is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    isPl95: Yup.object().required('PL 95 is required').nullable(),
    isCollection: Yup.object().required('Is Collection is required').nullable(),
    letterFor: Yup.object().required('Letter For is required').nullable(),
    minimumBalance: Yup.number().required('Min Balance is required'),
    minimumGapFromLastLetter: Yup.number().required('Min Days From Last Letter is required'),
    // minimumGapForNextLetter: Yup.number().required("Min Days For Next Letter is required"),
    minimumGapForNextLetter: Yup.number().test(
      'minimumGapForNextLetter',
      'Min Days For Next Letter is required',
      (value, ctx) => {
        if (isNaN(value) && ctx?.parent?.isCollection?.value === 'Yes') {
          return false;
        } else {
          return true;
        }
      },
    ),
    minimumDaysForResend: Yup.number().required('Min Days For Resend is required'),
    deliveryMethod: Yup.object().required('Delivery Method is required').nullable(),
  });
  window.onclick = function() {
    setCodePopover(false);
  };
  const handleErrorMessage = (width, length) => {
    return sideNavSection && width <= 1366 && length >= 45 ?
      'letterCode-validation' :
      'lettermaintenance-code-validation';
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          const check = JSON.stringify(touched) === '{}' ? false : dirty;
          handleDirty(check);

          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row standard-field-textfields new-standard-textfields mt-2">
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    disabled={Boolean(basicInfoData?.letterCode)}
                    placeholder={`Enter Letter Code`}
                    label="Letter Code"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="letterCode"
                    required
                    value={values?.letterCode}
                    inputRef={codeRef}
                    onChange={(e) => {
                      const value = upperCaseCode(codeRef);
                      setFieldValue('letterCode', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setFilterCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.letterCode}
                    error={Boolean(touched.letterCode && errors.letterCode)}
                  />

                  <div
                    className={handleErrorMessage(
                      window.screen.availWidth,
                      errors?.letterCode?.length,
                    )}
                  >
                    <FormHelperText style={{color: 'red'}}>
                      {touched.letterCode && errors?.letterCode && errors.letterCode}
                    </FormHelperText>
                  </div>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getFilterCodesData()?.map((data) => (
                        <MenuItem key={data?.letterCode}>{data?.letterCode}</MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Letter Description`}
                    label="Letter Description"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="letterDescription"
                    required
                    value={values?.letterDescription}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('letterDescription', e.target.value);
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.code}
                    error={Boolean(touched.letterDescription && errors.letterDescription)}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.letterDescription &&
                      errors?.letterDescription &&
                      errors.letterDescription}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    type="text"
                    placeholder={`Enter Days`}
                    label="Days In Agency"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputComponent: positiveNumberOnly,
                    }}
                    name="daysInAgency"
                    required
                    value={values?.daysInAgency}
                    onChange={(e) => {
                      // handleChange(e);
                      setFieldValue('daysInAgency', e.target.value);
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.daysInAgency}
                    error={Boolean(touched.daysInAgency && errors.daysInAgency)}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.daysInAgency && errors?.daysInAgency && errors.daysInAgency}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="letterType"
                    id="letterType"
                    size="small"
                    value={values.letterType}
                    onBlur={handleBlur}
                    disabled={Boolean(basicInfoData?.letterType)}
                    options={getOptions(LETTER_TYPE).length > 0 ? getOptions(LETTER_TYPE) : []}
                    getOptionLabel={(option) => {
                      return option?.value ? option?.value : '';
                    }}
                    onChange={(e, value) => {
                      if (value?.value === 'Print Service') {
                        handleHideStep(true);
                      } else {
                        handleHideStep(false);
                      }
                      // handleHideStep(["Bacompt"]?.includes(value?.value));
                      handleChange(e);
                      setFieldValue('letterType', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          touched={touched.letterType}
                          error={touched.letterType && errors.letterType}
                          margin="dense"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Letter Type"
                          placeholder="Select Letter Type"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.letterType && errors?.letterType && errors.letterType}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="isPl95"
                    id="isPl95"
                    size="small"
                    value={values.isPl95}
                    options={PlOptions}
                    onBlur={handleBlur}
                    getOptionLabel={(option) => {
                      return option && option?.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('isPl95', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          touched={touched.isPl95}
                          error={touched.isPl95 && errors.isPl95}
                          margin="dense"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Is PL 95"
                          placeholder="Select Is PL 95"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.isPl95 && errors?.isPl95 && errors.isPl95}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="isCollection"
                    id="isCollection"
                    size="small"
                    value={values.isCollection}
                    onBlur={handleBlur}
                    options={IsCollectionOptions}
                    disabled={basicInfoData?.isCollection}
                    getOptionLabel={(option) => {
                      return option && option?.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('isCollection', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          touched={touched.isCollection}
                          error={touched.isCollection && errors.isCollection}
                          margin="dense"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Is Collection"
                          placeholder="Select Is Collection"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.isCollection && errors?.isCollection && errors.isCollection}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="letterFor"
                    id="letterFor"
                    size="small"
                    value={values.letterFor}
                    onBlur={handleBlur}
                    options={getOptions(LETTER_FOR).length > 0 ? getOptions(LETTER_FOR) : []}
                    getOptionLabel={(option) => {
                      return option && option?.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('letterFor', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          touched={touched.letterFor}
                          error={touched.letterFor && errors.letterFor}
                          margin="dense"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Letter For"
                          placeholder="Select Letter For"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.letterFor && errors?.letterFor && errors.letterFor}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    type="text"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      inputComponent: Currency,
                    }}
                    placeholder={`Enter Min Balance`}
                    label="Min Balance"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="minimumBalance"
                    required
                    value={values?.minimumBalance}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('minimumBalance', e.target.value);
                    }}
                    fullWidth
                    touched={touched.minimumBalance}
                    error={Boolean(touched.minimumBalance && errors.minimumBalance)}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.minimumBalance && errors?.minimumBalance && errors.minimumBalance}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    type="text"
                    placeholder={`Enter Min Days From Last Letter`}
                    onBlur={handleBlur}
                    label="Min Days From Last Letter"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputComponent: positiveNumberOnly,
                    }}
                    name="minimumGapFromLastLetter"
                    required
                    value={values?.minimumGapFromLastLetter}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('minimumGapFromLastLetter', e.target.value);
                    }}
                    fullWidth
                    touched={touched.minimumGapFromLastLetter}
                    error={Boolean(
                      touched.minimumGapFromLastLetter && errors.minimumGapFromLastLetter,
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.minimumGapFromLastLetter &&
                      errors?.minimumGapFromLastLetter &&
                      errors.minimumGapFromLastLetter}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    type="text"
                    onBlur={handleBlur}
                    placeholder={`Enter Min Days for Resend`}
                    label="Min Days for Resend"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputComponent: positiveNumberOnly,
                    }}
                    name="minimumDaysForResend"
                    required
                    value={values?.minimumDaysForResend}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('minimumDaysForResend', e.target.value);
                    }}
                    fullWidth
                    touched={touched.minimumDaysForResend}
                    error={Boolean(touched.minimumDaysForResend && errors.minimumDaysForResend)}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.minimumDaysForResend &&
                      errors?.minimumDaysForResend &&
                      errors.minimumDaysForResend}
                  </FormHelperText>
                </div>
                {values?.isCollection?.key === 'Y' ? (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <TextField
                      className={`${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      type="text"
                      placeholder={`Enter Min Days For Next Letter`}
                      label="Min Days For Next Letter"
                      onBlur={handleBlur}
                      InputProps={{
                        inputComponent: positiveNumberOnly,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="minimumGapForNextLetter"
                      required
                      value={values?.minimumGapForNextLetter}
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue('minimumGapForNextLetter', e.target.value);
                      }}
                      fullWidth
                      touched={touched.minimumGapForNextLetter}
                      error={Boolean(
                        touched.minimumGapForNextLetter && errors.minimumGapForNextLetter,
                      )}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.minimumGapForNextLetter &&
                        errors?.minimumGapForNextLetter &&
                        errors.minimumGapForNextLetter}
                    </FormHelperText>
                  </div>
                ) : null}
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="deliveryMethod"
                    id="deliveryMethod"
                    size="small"
                    value={values.deliveryMethod}
                    onBlur={handleBlur}
                    options={
                      getOptions(DELIVERY_METHOD).length > 0 ? getOptions(DELIVERY_METHOD) : []
                    }
                    getOptionLabel={(option) => {
                      return option && option?.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('deliveryMethod', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          touched={touched.deliveryMethod}
                          error={touched.deliveryMethod && errors.deliveryMethod}
                          margin="dense"
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Delivery Method"
                          placeholder="Select Delivery Method"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.deliveryMethod && errors?.deliveryMethod && errors.deliveryMethod}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <FormControl margin="dense">
                    <FormControlLabel
                      className={`global-fields-checkbox ${classes.checkRoot}`}
                      control={
                        <Checkbox
                          onChange={handleChange}
                          name="isActive"
                          checked={values.isActive}
                        />
                      }
                      label="Is Active"
                      labelPlacement="end"
                    />
                  </FormControl>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                <Button
                  variant="outlined"
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  disabled={activeStep === 0}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    handleSubmit();
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={(editExisting && !LetterMainAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                    handleSubmit();
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};
export default BasicInfo;
